// extracted by mini-css-extract-plugin
export var image = "ft_bS";